// 基于1920px设计稿的适配方案
(function() {
	const baseSize = 16 // 基础大小 1rem = 16px
	const designWidth = 1920 // 设计稿宽度
	let device = detectDevice()
	let isInWeixin = isWeixin()

	function setRem() {
		// if (device != 'desktop'){
			let scale = document.documentElement.clientWidth / designWidth
			// scale = Math.min(scale, 3)
			// if(isInWeixin){
			// 	document.body.style.fontSize = (baseSize * scale) + 'px'
			// }else{
				document.documentElement.style.fontSize = (baseSize * scale) + 'px'
			// }

			console.log('rem scale', scale)
		// }

	}
	
	function isWeixin(){
		return /MicroMessenger/i.test(navigator.userAgent);
	}

	// 设备检测函数
	function detectDevice() {
		const userAgent = navigator.userAgent;
		const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
		const isTablet = /iPad|Android.*Tablet|Tablet.*Android/i.test(userAgent);

		if (isMobile && !isTablet) {
			return 'mobile';
		} else if (isTablet) {
			return 'tablet';
		} else {
			return 'desktop';
		}
	}
	setRem()
	window.addEventListener('resize', setRem)
})()